import config from "@/config"
import http from "@/utils/request"

export default {
	index: {
		url: `${config.API_URL}/bwmall/admin/feedback/index`,
		name: "意见反馈列表",
		get: async function(params){
			return await http.get(this.url, params);
		}
	},
	reply: {
		url: `${config.API_URL}/bwmall/admin/feedback/reply`,
		name: "回复意见反馈",
		post: async function(params){
			return await http.post(this.url, params);
		}
	},
	close: {
		url: `${config.API_URL}/bwmall/admin/feedback/close`,
		name: "关闭意见反馈",
		post: async function(params){
			return await http.post(this.url, params);
		}
	},
	del: {
		url: `${config.API_URL}/bwmall/admin/feedback/del`,
		name: "删除意见反馈",
		post: async function(params){
			return await http.post(this.url, params);
		}
	}
}
